<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-23 17:01:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-06-23 17:32:45
 * @name: 品质审批
 * @Description: 品质审批
 * @FilePath: \project\src\components\afterSale\dialog-approve-pinzhisp.vue
 * @Author: desktop
-->
<template>
  <div>
    <el-dialog
      title="审批处理"
      width="650px"
      :visible.sync="show"
      @close="close"
    >
      <div class="content">
        <div class="row">
          <font class="label">审批结果</font>
          <font class="text">审批通过</font>
        </div>
        <div class="row">
          <font class="label">审批建议</font>
          <el-input
            class="remark"
            type="textarea"
            :rows="2"
            :placeholder="'请输入审批建议...'"
            v-model="remark"
          >
          </el-input>
        </div>
        <div class="row">
          <font class="label">不合格原因分析</font>
          <el-input
            class="remark"
            type="textarea"
            :rows="2"
            :placeholder="'请输入不合格原因分析...'"
            v-model="cause_analysis"
          >
          </el-input>
        </div>
        <div class="row">
          <font class="label" style="line-height: 28px">处理意见</font>
          <div class="deal_notice">
            <el-select
              size="mini"
              class="deal_notice_choose"
              v-model="deal_notice_choose"
              placeholder="请选择处理意见模板"
            >
              <el-option
                :label="item.label"
                :value="item.label"
                v-for="item of deal_notice_template"
                :key="item.label"
              ></el-option>
            </el-select>
            <el-input
              class="remark"
              type="textarea"
              :rows="4"
              :placeholder="'请输入处理意见...'"
              v-model="deal_notice"
            >
            </el-input>
          </div>
        </div>
        <div class="departments">
          <div
            class="item"
            v-for="item of departments"
            :key="item.name"
            @click="item.value = item.value === 1 ? 0 : 1"
          >
            <span>{{ item.text }}</span>
            <div class="checkbox" :class="{ checked: item.value === 1 }">
              <img src="@/assets/icon/hook-white.png" v-if="item.value === 1" />
            </div>
          </div>
        </div>
        <div class="row">
          <font class="label">责任单位</font>
          <div class="duty">
            <div class="duty-row">
              <el-radio :label="1" v-model="accountability_unit_type"
                >默认琴行</el-radio
              >
            </div>
            <div class="duty-row">
              <el-radio :label="2" v-model="accountability_unit_type"
                >物流单位</el-radio
              >
              <el-input
                size="mini"
                v-model="duty_logistics"
                :disabled="accountability_unit_type !== 2"
                readonly
                @click.native="chooseCompany"
              ></el-input>
            </div>
            <div class="duty-row">
              <el-radio :label="3" v-model="accountability_unit_type"
                >其他</el-radio
              >
              <el-input
                size="mini"
                v-model="duty_other"
                :disabled="accountability_unit_type !== 3"
              ></el-input>
            </div>
          </div>
        </div>
        <!-- 选择图片input -->
        <input
          type="file"
          accept="image/*"
          id="filed"
          hidden
          @change="filePreview"
        />
        <div class="row">
          <font class="label">评审结果</font>
          <div class="img-group">
            <div class="img-box" v-for="(item, index) of image" :key="item">
              <img :src="item" class="image" />
              <div class="floating">
                <img src="@/assets/icon/eye.png" @click="showBigImage(item)" />
                <img
                  src="@/assets/icon/delete.png"
                  @click="deleteImage(index)"
                />
              </div>
            </div>
            <div class="img-select" @click="selectImg()">
              <i class="el-icon-folder-add"></i>
            </div>
          </div>
        </div>
        <div class="btn-group">
          <el-button size="mini" @click="show = false">取消</el-button>
          <el-button size="mini" type="primary" @click="confirm"
            >提交</el-button
          >
        </div>
      </div>
      <big-image ref="bigImage"></big-image>
    </el-dialog>
    <dialog-choose-company
      ref="dialogChooseCompany"
      :list="company_list"
      @chooseCompany="chooseCompanyHandler"
    ></dialog-choose-company>
  </div>
</template>
<script>
import issueService from "@/module/issue/issue.service";
import commonService from "@/module/common/common.service";
import bigImage from "@/components/public/big-image.vue";
import { debounceation } from "@/utils/decorator";
import { client, client_config } from "@/utils/alioss.js";
import { departments, deal_notice_template } from "@/config/afterSale.config";
import dialogChooseCompany from "@/components/afterSale/dialog-choose-company.vue";
export default {
  components: {
    bigImage,
    dialogChooseCompany,
  },
  data() {
    return {
      commonService: new commonService(),
      issueService: new issueService(),
      show: false,
      issue_id: "", //工单id
      run_process_id: "", //工作流id
      type: "", //审批结果 resolve 通过 reject 拒绝
      value: "", //act字段
      remark: "", //备注
      cause_analysis: "", //不合格原因分析
      deal_notice: "", //处理意见
      image: [], //图片
      departments: [], //部门
      deal_notice_template: [], //处理意见模板列表
      company_list: [], //物流公司列表
      accountability_unit_type: 1, //责任单位类型
      com: "", //物流公司代号
      duty_logistics: "", //物流单位
      duty_other: "", //其他
      deal_notice_choose: "", //处理意见模板选择
    };
  },
  watch: {
    accountability_unit_type: {
      handler(nv, ov) {
        this.duty_logistics = "";
        this.duty_other = "";
        this.com = "";
      },
      immediate: false,
      deep: true,
    },
    deal_notice_choose: {
      handler(nv, ov) {
        this.deal_notice =
          this.deal_notice_template?.find(
            (x) => x.label === this.deal_notice_choose
          )?.value ?? "";
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取快递公司列表
     */
    getCompany() {
      this.issueService.getCompanyName().then((res) => {
        let company_list = [];
        for (let x in res.items) {
          company_list.push({
            company: x,
            com: res.items[x].com,
            company_name: res.items[x].company_name,
          });
        }
        this.company_list = company_list;
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} item 传递数据
     */
    open(param) {
      this.getCompany();
      this.departments = JSON.parse(JSON.stringify(departments));
      this.deal_notice_template = JSON.parse(
        JSON.stringify(deal_notice_template)
      );
      this.deal_notice_choose = this.deal_notice_template[0].label;
      this.issue_id = param.issue_id;
      this.run_process_id = param.run_process_id;
      this.type = param.type;
      this.value = param.value;
      this.show = true;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 弹窗关闭回调
     */
    close() {
      this.type = "";
      this.value = "";
      this.remark = "";
      this.cause_analysis = "";
      this.deal_notice = "";
      this.image = [];
      this.departments = [];
      this.accountability_unit_type = 1;
      this.duty_logistics = "";
      this.duty_other = "";
      this.com = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择快递公司
     */    
    @debounceation(300)
    chooseCompany() {
      if (this.accountability_unit_type !== 2) {
        return;
      }
      this.$refs.dialogChooseCompany.open(this.com);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择快递公司回调
     * @param {Object} obj 快递公司信息
     */
    chooseCompanyHandler(obj) {
      this.com = obj.com;
      this.duty_logistics = obj.company_name;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击产品图片框,触发input[type=file]的上传事件，调用filePreview函数
     */
    @debounceation(300)
    selectImg() {
      document.getElementById("filed").click();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 上传图片
     * @param {Object} e input[type=file]回调
     */
    @debounceation(300)
    filePreview(e) {
      let file = e.target.files[0];
      e.target.value = "";
      if (file) {
        if (file.type.indexOf("image") === -1) {
          this.$message.error("上传格式有误,请上传图片!");
          return;
        }
        const fileName =
          "images/" +
          `${new Date().getTime() + Math.floor(Math.random() * 150)}` +
          ".png";
        this.commonService.getUploadStsToken().then(res => {
          const { AccessKeyId, AccessKeySecret, SecurityToken } = res.data;
          client(AccessKeyId,AccessKeySecret,SecurityToken)
            .multipartUpload(fileName, file)
            .then((result) => {
              const img_file = client_config.fileHost + result.name;
              this.image.push(img_file);
            });
        });
      }
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 查看大图
     * @param {String} path 图片地址
     */
    @debounceation(300)
    showBigImage(path) {
      this.$refs.bigImage.open(path);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除图片
     * @param {Number} index 图片数组索引
     */
    deleteImage(index) {
      this.image.splice(index, 1);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击提交
     */
    @debounceation(300)
    confirm() {
      let department = {};
      this.departments.forEach((x) => {
        department[x.name] = x.value;
      });
      let req = {
        issue_id: this.issue_id,
        run_process_id: this.run_process_id,
        remark: this.remark,
        quality_verify_res_url: this.image.join(","),
        cause_analysis: this.cause_analysis,
        deal_notice: this.deal_notice,
        department,
      };
      req.accountability_unit_type = this.accountability_unit_type;
      if (Number(this.accountability_unit_type) === 1) {
        req.accountability_unit_name = "";
      } else if (Number(this.accountability_unit_type) === 2) {
        req.accountability_unit_name = this.duty_logistics;
      } else if (Number(this.accountability_unit_type) === 3) {
        req.accountability_unit_name = this.duty_other;
      }
      this.issueService.qualityVerify(req).then((res) => {
        this.$emit("finish");
        this.show = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  @extend .et-flex-column-normal;
  .row {
    width: 100%;
    margin-bottom: 18px;
    @extend .et-flex-normal;
    font-size: $Vars-font-content-size;
    .label {
      color: $Vars-font-important-color;
      width: calc(#{$Vars-font-content-size} * 7);
      font-weight: bold;
      margin-right: 10px;
    }
    .text {
      color: $Vars-font-normal-color;
    }
    .remark {
      flex: 1;
    }
    .deal_notice {
      flex: 1;
      @extend .et-flex-column-normal;
      .deal_notice_choose {
        width: 100%;
        margin-bottom: 20px;
      }
    }
    .img-group {
      @include grid-column(4, 100px, 10px);
      row-gap: 10px;
      .img-box {
        width: 100px;
        height: 100px;
        border-radius: $Vars-border-radius-normal;
        border: 1px solid $Vars-border-fourth-color;
        overflow: hidden;
        position: relative;
        img {
          width: 100px;
          height: 100px;
        }
        .floating {
          display: none;
        }
        &:hover {
          .floating {
            position: absolute;
            top: 0;
            left: 0;
            width: 100px;
            height: 100px;
            background: rgba(0, 0, 0, 0.3);
            z-index: 1;
            @extend .et-clickElement;
            @extend .et-flex-center;
            img {
              margin-right: 10px;
              &:last-child {
                margin: 0 !important;
              }
              width: 20%;
              height: 20%;
            }
          }
        }
      }
      .img-select {
        width: 100px;
        height: 100px;
        border: 1px dashed $Vars-font-placeholder-color;
        border-radius: $Vars-border-radius-normal;
        overflow: hidden;
        @extend .et-clickElement;
        @extend .et-flex-center;
        i {
          font-size: 40px;
          color: $Vars-font-placeholder-color;
        }
      }
    }
    .duty {
      flex: 1;
      @extend .et-flex-column-normal;
      .duty-row {
        width: 100%;
        @extend .et-flex-start;
        &:not(:first-child) {
          margin-top: 10px;
        }
        .el-radio {
          width: 100px;
        }
        .el-input {
          width: 200px;
        }
      }
    }
  }
  .departments {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    margin: 10px 5px;
    @extend .et-flex-normal;
    .item {
      width: 25%;
      margin-bottom: 10px;
      @extend .et-flex-normal;
      @extend .et-clickElement;
      span {
        font-size: 12px;
        line-height: 12px;
        width: 60px;
      }
      .checkbox {
        margin-left: 5px;
        width: 14px;
        height: 14px;
        box-sizing: border-box;
        border-radius: 2px;
        border: 1px solid #ccc;
        @extend .et-flex-center;
        &.checked {
          border-color: $Vars-normal-color;
          background: $Vars-normal-color;
        }
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  .btn-group {
    width: 100%;
    @extend .et-flex-center;
  }
}
</style>